export default [{
    header: 'Inicio',
    title: 'Página Principal',
    icon: 'HomeIcon',
    route: 'home',
    action: 'read',
    resource: 'ACL'
}]